import React from 'react';
import { Card, CardBody, Col, Badge } from 'reactstrap';

const Overview = ({ detail }) => {
    return (
        <React.Fragment>
            <Col xl={4}>
                {/* YENİ EKLENEN: FİNANS VE ÖZET KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <h5 className="fw-bold mb-4">Finans ve Özet</h5>
                        
                        <div className="mb-3">
                            <span className="text-muted d-block mb-1 text-uppercase fs-12">Toplam Ücret</span>
                            <h4 className="fw-bold text-success mb-0">{detail.price} TL</h4>
                        </div>
                        
                        <hr />
                        
                        <div className="mb-3">
                            <span className="text-muted d-block mb-1 text-uppercase fs-12">Fatura Durumu</span>
                            {detail.invoice ? (
                                <Badge color={detail.invoice.status === 'Ödendi' ? 'success' : 'warning'} className="fs-13 p-2">
                                    #{detail.invoice.number} - {detail.invoice.status}
                                </Badge>
                            ) : (
                                <Badge color="light" className="text-dark border fs-13 p-2">Fatura Yok</Badge>
                            )}
                        </div>
                        
                        <div className="mb-3">
                            <span className="text-muted d-block mb-1 text-uppercase fs-12">İlan Tipi / Yön</span>
                            <Badge color="info" className="me-1">{detail.advertTypeTitle}</Badge>
                            <Badge color={detail.direction.includes('Git') ? 'primary' : 'secondary'}>{detail.direction}</Badge>
                        </div>

                        <div className="mb-0">
                            <span className="text-muted d-block mb-1 text-uppercase fs-12">Son Teslimat (Deadline)</span>
                            <span className="fw-medium text-dark">
                                <i className="mdi mdi-calendar-clock text-danger me-1"></i> 
                                {detail.deadline}
                            </span>
                        </div>
                    </CardBody>
                </Card>

                {/* MEVCUT MOBİL QR KOD KARTI */}
                <Card 
                    className="bg-dark text-white rounded-3 overflow-hidden position-sticky shadow-lg" 
                    style={{ top: "80px" }} // Sayfa scroll olduğunda ekranda sabit kalsın diye
                >
                    <div 
                        className="p-4 text-center h-100" 
                        style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
                    >
                        <div className="mb-3 mt-2">
                            <i className="mdi mdi-lock text-white" style={{ fontSize: "50px" }}></i>
                        </div>
                        
                        <h4 className="text-white mb-3">Taşıma No. {detail.id}</h4>
                        
                        <p className="text-light fs-14 mb-4" style={{ lineHeight: "1.6" }}>
                            Ulaşımın belirli kısıtlamaları nedeniyle, teklif baskısı yalnızca mobil uygulamada mevcuttur.
                        </p>
                        
                        {/* QR Kod Alanı */}
                        <div className="bg-white p-2 rounded d-inline-block mb-3">
                            <i className="mdi mdi-qrcode-scan display-1 text-dark"></i>
                        </div>
                        
                        <div className="text-light fs-14 mb-3 fw-medium">
                            <span className="d-block mb-1">⬆️ Görev detaylarına erişin</span>
                            <span className="d-block">Bu QR Kodunu taramak 📸</span>
                        </div>
                    </div>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default Overview;